export default __webpack_public_path__ + "static/media/Miscellaneous13.02fa909b.jpg";